module.exports = __webpack_public_path__ + "img/sourcing@2x.831e5af.webp";